import { NavigationGuard } from "vue-router";

export const requestIdGuard: NavigationGuard = async (to, from, next) => {
    if (!isNaN(Number(to.params.requestId))) {
        next();
    } else {
        next({name: "not-found"});
    }
};
